import React from "react";

import {
  getProfileTypeColor,
  ProfileTypeName
} from "@platformsh/observability-graph/ContinuousProfiling";

import * as S from "./ProfileTypeBullet.styles";

type ProfileTypeBulletProps = {
  profileTypeName: ProfileTypeName;
};

const ProfileTypeBullet = ({ profileTypeName }: ProfileTypeBulletProps) => {
  return <S.Bullet color={getProfileTypeColor(profileTypeName)} />;
};

export default ProfileTypeBullet;
